import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class FreService {

    private readonly FRE_KEY = 'showedFRE';

    hasShownFRE(): boolean {
        const result = localStorage.getItem(this.FRE_KEY) === 'true';
        return result;
    }

    markFREAsShown(): void {
        localStorage.setItem(this.FRE_KEY, 'true');
    }
}
